export const CAROUSEL_ITEMS = [1, 2, 3];
